import {
    GABE_IMPORTS_KEY,
    MultipleGabeImportJobsState, selectAllMultipleGabeImportJobs,
    selectMultipleGabeImportJobsEntities, selectMultipleGabeImportJobsFetched,
    selectMultipleGabeImportJobsLatestUpdatedAt,
} from '../reducers/multiple-gabe-import-jobs.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';


const selectState = createFeatureSelector<MultipleGabeImportJobsState>(GABE_IMPORTS_KEY);

export const getMultipleGabeImportJobsDictionary = createSelector(selectState, selectMultipleGabeImportJobsEntities);
export const getMultipleGabeImportJobss = createSelector(selectState, selectAllMultipleGabeImportJobs);
export const getMultipleGabeImportJobssFetched = createSelector(selectState, selectMultipleGabeImportJobsFetched);
export const getMultipleGabeImportJobsLatestUpdatedAt = createSelector(selectState, selectMultipleGabeImportJobsLatestUpdatedAt);

export const getMultipleGabeImportJobsById = (props: { id: number }) => createSelector(getMultipleGabeImportJobsDictionary, (dictionary) => props?.id && dictionary[props.id]);
